<rma-skip-to-content />

@if (showHeader()) {
  <rma-header
    [trialDays]="(trialDays$ | async) ?? 0"
    [isSubscribed]="(isSubscribed$ | async) ?? false"
    [displaySideNavButton]="showSideNav()"
    [hasSideNav]="showSideNav()"
    [class.collapsed]="sideNavCollapsed()"
    (menuButtonClicked)="onToggleSideNav()"
  />
}

@if (showSideNav()) {
  <rma-side-nav
    [class.collapsed]="sideNavCollapsed()"
    [visible]="mobileSideNavVisible()"
    [collapsed]="sideNavCollapsed()"
    (navigated)="onNavigation()"
    (subMenuExpanded)="onToggleDesktopSideNav()"
    (toggleSideNav)="onToggleDesktopSideNav()"
  />
}

<main id="rma-main-content" [class.has-header]="showHeader()" [class.collapsed]="sideNavCollapsed()" [class.has-side-nav]="showSideNav()">
  <router-outlet />
</main>

@if (enableIntercom$ | async) {
  <rma-intercom-messenger-bot class="fixed right-0 top-80 z-10 md:hidden" />
}
